export const byMax = (k: string) => (acc, val) => (acc < val[k]) ? acc : val;